module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/press/tech-stack-anniversary/tech-stack-anniversary.component.scss
// module id = 789
// module chunks = 0